import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import LandingPage from './routes/LandingPage'
import SubscriptionPage from './routes/SubscriptionPage'
import HomePage from './routes/HomePage'
import GamePage from './routes/GamePage'
import LoginPage from './routes/LoginPage'
import OtpPage from './routes/OtpPage'
import LeaderboardPage from './routes/LeaderboardPage'
import ProfilePage from './routes/ProfilePage'
import WinnersPage from './routes/WinnersPage'
import CategoryPage from './routes/CategoryPage'
import LanguageSelector from './component/LanguageSelector'

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <>
        <LandingPage />
        <LanguageSelector />
      </>
    },
    {
      path: "/subscribe",
      element: 
      <>
      <SubscriptionPage />
          <LanguageSelector />
      </>
    },
    {
      path: "/login",
      element: 
      <>
      <LoginPage />
          <LanguageSelector />
      </>
    },
    {
      path: "/otp",
      element: 
      <>
      <OtpPage />
          <LanguageSelector />
      </>
    },
    {
      path: "/home",
      element: 
      <>
      <HomePage />
          <LanguageSelector />
      </>
    },
    {
      path: "/category",
      element: 
      <>
      <CategoryPage />
          <LanguageSelector />
      </>
    },
    {
      path: "/game",
      element: <GamePage />
    },
    {
      path: "/winners",
      element: 
      <>
      <WinnersPage />
          <LanguageSelector />
      </>
    },
    {
      path: "/leaderboard",
      element: 
      <>
      <LeaderboardPage />
          <LanguageSelector />
      </>
    },
    {
      path: "/profile",
      element: 
      <>
      <ProfilePage />
          <LanguageSelector />
      </>
    }
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default App